import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lock",
  "use": "lock-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"lock\"><g fill-rule=\"evenodd\"><path d=\"M4 8h12v10H4z\" opacity=\".12\" /><path d=\"M3 9c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V9Zm1 0c0-.55.46-1 1-1h10c.55 0 1 .46 1 1v8c0 .55-.46 1-1 1H5c-.55 0-1-.46-1-1V9Zm2-5c0-1.66 1.34-3 3-3h2c1.66 0 3 1.35 3 3v3H6V4Zm1 0c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v3H7V4Zm2 9c0-.55.44-1 1-1 .55 0 1 .44 1 1 0 .55-.44 1-1 1-.55 0-1-.44-1-1Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol